"use strict";var nextComponentIdProvider =
require("@internal/components-util")._U_;

function GlobalComponentsContext(out) {
  this.q_ = {};
  this.aB_ = undefined;
  this.aQ_ = nextComponentIdProvider(out);
}

module.exports = GlobalComponentsContext;